import { AspContact, AspContactsRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspVendors() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [vendors, setVendors] = useState<AspContact[]>([]);

  async function fetchAspVendors(params: AspContactsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspVendors(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setVendors(res.Vendors);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, vendors, fetchAspVendors };
}
